import React, { useState } from "react"
import LoadingButton from "@mui/lab/LoadingButton"
import Button from "@mui/material/Button"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import TextField from "@mui/material/TextField"
import { useSnackbar } from "notistack"
import { useForm } from "react-hook-form"
import { updateMemberEmail } from "services/member"
import { verifyResponse } from "utils/httpRequest"
import { StyledModalMemberPasswordResetDialog } from "./Member.style"

const MemberUpdateEmailDlg = ({ refreshMemberDetail }) => {
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)
  const [memberId, setMemberId] = useState(0)

  const { enqueueSnackbar } = useSnackbar()

  const {
    register,
    handleSubmit,
    reset,
  } = useForm()

  const handleClose = () => {
    setOpen(false)
  }
  const openDlg = (userId) => {
    setMemberId(userId)
    setOpen(true)
  }

  const changeAccountEmail = async ({ newEmail }) => {
    setLoading(true)
    try {
      const response = await updateMemberEmail({
        memberId,
        newEmail,
      })
      verifyResponse(response)

      if (response.rtnCode === 200) {
        refreshMemberDetail()
        enqueueSnackbar("Update Email Address Succeeded!", {
          variant: "success",
        })
        reset()
        setOpen(false)
      } else {
        enqueueSnackbar("Fail Update Email Address", {
          variant: "warning",
        })
      }
    } finally {
      setLoading(false)
    }
  }

  const handleAction = async (data) => {
    // send request
    await changeAccountEmail({ newEmail: data.newEmail })

    // send notification message here
  }
  const dlg = (
    <StyledModalMemberPasswordResetDialog open={open} onClose={handleClose}>
      <DialogTitle>
        <div className="dialog-title-group">
          <h2 className="dialog-title">Update Account Email</h2>
          <p className="dialog-subtitle">
            Send an email update request for this member account.
          </p>
        </div>
      </DialogTitle>
      <DialogContent>
        <form
          onSubmit={handleSubmit(handleAction)}
          className="email-change-form"
        >
          <TextField
            type="email"
            label="New Email Address"
            required
            variant="outlined"
            size="small"
            {...register("newEmail", {
              required: "New Email address is required",
            })}
          />

          <LoadingButton
            className="dialog-submit-btn"
            loading={loading}
            loadingIndicator="Updating..."
            type="submit"
            size="medium"
            variant="contained"
          >
            Send Email Update Request
          </LoadingButton>
        </form>
      </DialogContent>
      <DialogActions>
        <Button
          className="dialog-close-btn"
          variant="outlined"
          size="medium"
          onClick={handleClose}
        >
          Close
        </Button>
      </DialogActions>
    </StyledModalMemberPasswordResetDialog>
  )

  return [openDlg, dlg, loading]
}

export default MemberUpdateEmailDlg
